import React from 'react'
import './home.css'

import { Link } from "react-router-dom"
import bitcoin from './images/bg-2.png';

function Home() {
    return (
        <div className='home'>
            <div className="homebody">
                <div className="container">
                    <div>
                        <h2 id='home_head'>Take a Step into</h2>
                        <h2 id='home_head'>the <span id='home_span'>Crypto World</span></h2>
                    </div>
                    <div>
                        <h6 id='home_para'>So you want to buy Bitcoins. Bitcoins are one of many trendy Cryptocurrencies sold on internet today. Buy and Sell Digital Currency.</h6></div>

                    <button id="btn"><Link to="/coins">Get Started</Link></button>

                </div>
                <div className="image">
                    <img id='img' src={bitcoin} alt="bitcoin.png" />
                </div>
            </div>
        </div>

    )
}

export default Home